import React, { useEffect, useMemo, useState, useContext } from "react";
// import AdminImg from '../../Img/usrpict.PNG';
import { RiEditBoxFill, RiFileEditFill } from "react-icons/ri";
import AdminImg from "../../Img/viewer.png";
// import Viewer from '../../Img/viewer.png'
// import campraImg from "../../Img/LOGORepository.png"
import campraImg from "../../Img/logo.png";
import remove from "../../Img/delete.png";
import edit from "../../Img/edit.png";
import CategoryList from "./CategoryList";
// <<<<<<< HEAD
import back from "../../Img/new home.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Spinner from "../Spinner";
import { toast } from "react-toastify";
import Viewer from "../../Img/viewer.png";
import myarticles from "../../Img/new article.png";
import { Dropdown, Modal, ProgressBar } from "react-bootstrap";
import TopNavBar from "../TopNavBar";
import SideBar from "../SideBar";
import { Base_Url, API_BASE_URL } from "../../utils/config";
// import { MdDeleteForever } from "react-icons/md";
import { MDBDataTable } from "mdbreact";
// import { FaImage, FaUserEdit } from "react-icons/fa";
import MdDeleteForever from "../../Img/delete.png";
import FaUserEdit from "../../Img/edit user.png";
import { IoEye } from "react-icons/io5";
import ImportArticleImage from "../../Img/import article.png";
import TransferAuthorImage from "../../Img/transfer author.png";
import CreateArticleImage from "../../Img/create article.png";
import EditFeatureImgage from "../../Img/edit featured.png";
import UploadImage from "../../Img/add featured image.png";
import WordUploadImg from "../../Img/update.png";
import NewTopNavBar from "../NewTopNavBar";
import GlobalContext from "../../context/GlobalContext";
import BulkDelete from "../../Img/delete.png";

import DocxImg from "../../Img/docx.png";
import PdfImg from "../../Img/pdf.png";
import PptxImg from "../../Img/ppt.png";
import UploadWordDoc from "../../Img/upload-document.png"
import cancelArticles from "../../Img/cross.png";
// import { ProgressBar } from "react-bootstrap";
const mammoth = require("mammoth/mammoth.browser");
// import mammoth from 'mammoth';
const cheerio = require("cheerio");

// =======
// import back from '../../Img/home_738822.png';
// >>>>>>> d8aaf382d53b54b6495407231a922f7960218c95

const TablePosts = () => {
  const navigate = useNavigate();
  const backBtn = () => {
    navigate("/searchLandingPage");
  };

  const { notificationCount, setNotificationCount } = useContext(GlobalContext);
  const [uploadingFileName, setUploadingFileName] = useState("");
  const [TotalSpace, setTotalSpace] = useState(0);
  const [uploadProgress, setUploadProgress] = useState(0); // State to track upload progress
  const [fileFraction, setFileFraction] = useState("0/0"); // State to track file fraction
  const [deletedFiles, setDeletedFiles] = useState([]); // State to track deleted files
  const [isUploading, setIsUploading] = useState(false);
  const [availableSpace, setAvailableSpace] = useState(0.5);
  const [usedSpace, setUsedSpace] = useState(0);
  const [wordUpload, setWordUpload] = useState(false);
  const [createArticle, setCreateArticle] = useState(false);
  const [totalNoOfUsers, setTotalNoOfUsers] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 5;
  const [apiResponse, setApiRespose] = useState([]);
  const [show, setShow] = useState(false);
  const [catagories, setCatagories] = useState([]);
  const [articles, setArticles] = useState([]);
  const [newDelete, setNewDelete] = useState(true);
  const [loader, setLoader] = useState(false);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const [hasMorePosts, setHasMorePosts] = useState(true); // New state to track if there are more posts to load
  const [reload, setReload] = useState(false);
  const [allCategories, setALLCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [collaps, setCollaps] = useState(true);
  const [allUsers, setAllUsers] = useState([]);
  const [featureImage, setFeatureImage] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [updatePostId, setUpdatePostId] = useState("");
  const [mediaIds, setmediaIds] = useState([]);
  const [authors, setAuthors] = useState([]);
  const [selectedAuthor, setSelectedAuthor] = useState("");
  //  localStorage.getItem("current_user_Id");
  const [checkboxValue, setCheckboxValue] = useState([]);
  const [changedAuthors, setChangeAuthors] = useState([]);
  const [featuredImageLoading, setFeaturedImageLoading] = useState(false);
  const [html, setHtml] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [modalShowWordDoc, setModalShowWordDoc] = useState(false);
  const [file, setFile] = useState([]);
  const [postTitle, setPostTitle] = useState("");
  const [getPdfFile, setGetPdfFile] = useState([]);
  const [getDocxFile, setGetDocxFile] = useState([]);
  const [getPptxFile, setPptxFile] = useState([]);
  const [categoryLength, setCategoryLength] = useState([]);
  const [structuredData, setStructuredData] = useState({
    postId: "",
    authorId: "",
  });
  const [isChecked, setIsChecked] = useState(false);
  const [checkedCheckboxes, setCheckedCheckboxes] = useState([]);
  const [disable, setDisable] = useState(true);
  const [checkedRows, setCheckedRows] = useState([]);
  let CurrentUserId = localStorage.getItem("current_user_Id");
  let bearerToken = localStorage.getItem("jwt_token");
  const config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };
  const getAllPdfFile = () => {
    axios.get(`${API_BASE_URL}/wp-json/media/v1/pdf`, config).then((res) => {
      setGetPdfFile(res.data.length);
    });
  };

  const getAllDocxFile = () => {
    axios.get(`${API_BASE_URL}/wp-json/media/v1/docx`, config).then((res) => {
      setGetDocxFile(res.data.length);
    });
  };
  const getAllPptxFile = () => {
    axios.get(`${API_BASE_URL}/wp-json/media/v1/pptx`, config).then((res) => {
      setPptxFile(res.data.length);
    });
  };

  // useEffect(() => {
  //   getAllPdfFile();
  //   getAllDocxFile();
  //   getAllPptxFile();
  // }, []);
  const deleteBtn = (deleteId) => {
    // setNewDelete(false)
    setCount(count + 1);
    const username = "ramnaresh";
    const password = "o(oLKgVkO28bHhKZ%L82Jv1C";
    const apiEndpoint = `${API_BASE_URL}/wp-json/wp/v2/posts/${deleteId}`;

    const config = {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        "Content-Type": "application/json",
      },
    };

    axios
      .delete(apiEndpoint, config)
      .then((response) => {
        toast.success(
          "Article Deleted Successfully"

          // , { toastId: 'category', autoClose: 100 }
        );
      })
      .catch((error) => {
        console.error("Error deleting post:", error);
      });
  };
  //

  //get available space api start

  const getAvailableSpace = () => {
    axios
      .get(`${API_BASE_URL}/wp-json/custom/v1/file-tracking`)
      .then((res) => {
        setAvailableSpace(
          Number(res.data.given_size) - Number(res.data.total_file_size_gb)
        );
        setTotalSpace(parseInt(res.data.given_size));
        setUsedSpace(Number(res.data.total_file_size_gb));
      })
      .catch((err) => { });
  };

  useEffect(() => {
    getAvailableSpace();
  }, [apiResponse.length]);

  //get available space api end

  const handleDelete = async (id) => {
    // setNewDelete(false)
    try {
      const confirmed = window.confirm(
        "Are you sure you want to delete this article?"
      );
      if (!confirmed) {
        return;
      }

      // const apiEndpoint = `${API_BASE_URL}/wp-json/wp/v2/posts/${id}`;
      const apiEndpoint = `${API_BASE_URL}/wp-json/custom/v1/delete-article?post_id=${id}`;

      const config = {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .delete(apiEndpoint, config)
        .then((response) => {
          toast.success("Article Deleted Successfully", {
            toastId: "category",
          });

          const postData = {
            postId: response.data.id,
          };

          axios
            .delete(
              `${window.location.origin}/backend_cosmos/refresh/deletePost/${response.data.id}`,
              // `https://krstaging.camptratech.com/backend_cosmos/refresh/deletePost/${response.data.id}`,
              postData
            )
            .then((res) => {
              console.log(res);
            })
            .catch((err) => {
              console.log(err);
              // toast.error(
              //   "Article deleted successfully, but AI database not updated."
              // );
            });

          setReload(reload ? false : true);

          setNotificationCount(notificationCount + 1);

          //
          let notification_count_specific_user = {
            user_id: response.data.author,
            count_value: "",
          };
          let notification_count = {
            user_id: "",
            count_value: notificationCount,
            reflect_count: "all_admin",
          };
          if (notification_count.user_id == "") {
            // post notification on usermeta start
            axios
              .post(
                `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                notification_count,
                config
              )
              .then((res) => { })
              .catch((err) => {
                console.log(err);
              });
          }
          if (notification_count_specific_user.user_id != "") {
            // post notification on usermeta start
            axios
              .post(
                `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                notification_count_specific_user,
                config
              )
              .then((res) => { })
              .catch((err) => {
                console.log(err);
              });
          }

          //

          //recomandation data
          let notification_api_data = {
            author: localStorage.getItem("display_name"),
            articles: response.data.title.rendered,
            event_type: "Delete Article",
            email: localStorage.getItem("userEmail"),
            article_ids: response.data.id,
            notification_ids: response.data.author,
            author_ids: localStorage.getItem("current_user_Id"),
          };

          axios
            .post(
              `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
              notification_api_data,
              config
            )
            .then((res) => { })
            .catch((err) => {
              console.log(err);
            });

          // recomandation data
        })
        .catch((error) => {
          console.error("Error deleting post:", error);
        });
    } catch (error) {
      console.error("Error deleting Enter Code data:", error);
    }
  };

  //

  useEffect(() => {
    if (!bearerToken) {
      navigate("/");
    } else {
      let sessionId = sessionStorage.getItem("sessionId");
      if (!sessionId) {
        let sessionId = Math.floor(Math.random() * 100000);
        sessionStorage.setItem("sessionId", sessionId);
        navigate("/all-articles");
      } else {
        const fetchCategories = async () => {
          // setNewDelete(true)
          setLoading(true);
          try {
            const response = await axios.get(
              `${API_BASE_URL}/wp-json/wp/v2/categories?per_page=100`,
              {
                headers: {
                  Authorization: `Bearer ${bearerToken}`,
                  "Content-Type": "application/json",
                },
              }
            );
            // alert(response.data.length);
            setCategoryLength(response.data.length);
            const categoryData = response.data.map((category) => ({
              id: category.id,
              name: category.name,
              parent: category.parent,
            }));
            setALLCategories(categoryData);
          } catch (error) {
            console.error("Error fetching categories:", error);
          } finally {
            setLoading(false);
          }

          // get all users

          try {
            const response = await axios.get(
              `${API_BASE_URL}/wp-json/custom-user-api/v1/users/`,
              {
                headers: {
                  Authorization: `Bearer ${bearerToken}`,
                  "Content-Type": "application/json",
                },
              }
            );
            // const categoryData = response.data.map((category) => ({
            //   id: category.id,
            //   name: category.name,
            // }));
            setAllUsers(response.data);
          } catch (error) {
            console.error("Error fetching categories:", error);
          } finally {
            setLoading(false);
          }
          // get all users
        };

        fetchCategories();

        //
        let ApiEndPoint = "";
        if (rolles == "author" || rolles == "editor") {
          // alert(CurrentUserId)
          // ApiEndPoint = `${API_BASE_URL}/wp-json/wp/v2/posts?status[]=publish&status[]=draft&author=${CurrentUserId}&per_page=100`
          ApiEndPoint = `${API_BASE_URL}/wp-json/custom/v1/posts/${CurrentUserId}`;
        } else {
          // ApiEndPoint = `${API_BASE_URL}/wp-json/wp/v2/posts?status[]=publish&status[]=draft&per_page=100`
          ApiEndPoint = `${API_BASE_URL}/wp-json/custom/v1/posts`;
        }

        axios
          .get(`${ApiEndPoint}`, {
            // axios.get(`${API_BASE_URL}/wp-json/wp/v2/posts?per_page=${perPage}&page=${page}`, {
            headers: {
              Authorization: `Bearer ${bearerToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            setTotalNoOfUsers(response.data.length);

            setCatagories(response.data);
            setApiRespose(response.data);
            setLoader(true);

            const pdfElements = document.querySelectorAll(".pdf-view");
            console.log("pdfElements", pdfElements);
          });
      }

      const getAllAuthors = () => {
        axios
          .get(`${API_BASE_URL}/wp-json/custom-user-api/v1/users/`, {
            headers: {
              Authorization: `Bearer ${bearerToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            // Filter out users with the role "subscriber"
            // console.log("235=", res)
            const filteredUsers = res.data.filter(
              (user) =>
                !user.user_roles.includes("subscriber")
                &&
                !user.user_roles.includes("administrator")
            );
            // console.log("filteredUsers", filteredUsers);
            // setUsers(filteredUsers);
            setAuthors(filteredUsers);
          })
          .catch((err) => {
            console.log(err);
          });
      };
      getAllAuthors();
    }

    getAllPdfFile();
    getAllDocxFile();
    getAllPptxFile();
  }, [reload]);

  //

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = apiResponse.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  //

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const rolles = localStorage.getItem("roles");

  //
  const logOutBtn = () => {
    sessionStorage.clear();
    navigate("/");
  };
  const handleEdit = (postId) => {
    localStorage.setItem("postId", postId);
    navigate("/edit-post");
  };
  const createPostHandel = () => {
    navigate("/create-post");
  };
  const changeCollapsState = () => {
    if (collaps) {
      setCollaps(false);
    } else {
      setCollaps(true);
    }
  };
  // view article

  const gotToArticlePage = (postId) => {
    localStorage.setItem("postId", postId);
    navigate(`/single-article?id=${postId}`);
  };

  // view article

  const handleClose = () => {
    setShow(false);
  };
  //feature Image

  const handleFileChange = (event) => {
    setFeaturedImageLoading(true);

    setSelectedFile(event.target.files[0]);

    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    const config2 = {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        "Content-Type": "multipart/form-data",
      },
    };
    // alert(parseInt(TotalSpace) > parseInt(availableSpace));
    if (availableSpace > 0) {
      axios
        .post(`${API_BASE_URL}/wp-json/wp/v2/media`, formData, config2)
        .then((res) => {
          setFeatureImage(res.data.guid.rendered);
          setFeaturedImageLoading(false);
          // track file size api call start
          const fileSize = {
            file_size: res.data.media_details.filesize,
          };
          axios
            .post(
              `${API_BASE_URL}/wp-json/custom/v1/track-filesize`,
              fileSize,
              {
                headers: { Authorization: `Bearer ${bearerToken}` },
              }
            )
            .then((response) => {
              setAvailableSpace(
                Number(res.data.given_size) -
                Number(res.data.total_file_size_gb)
              );
              setTotalSpace(parseInt(response.data.given_size));
              setUsedSpace(Number(res.data.total_file_size_gb));
            })
            .catch((error) => {
              console.log("Error:", error);
            });

          // track file size api call end
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setFeaturedImageLoading(false);
      setShow(false);
      toast.error("Contact the administrator for more space.");
    }
  };

  const handleEditFeaturedImage = (id) => {
    setUpdatePostId(id);

    // alert(id)
    const config = {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        "Content-Type": "application/json",
      },
    };
    // `${API_BASE_URL}/wp-json/wp/v2/posts?status[]=publish&status[]=draft&author=${CurrentUserId}&per_page=100`
    axios
      .get(`${API_BASE_URL}/wp-json/wp/v2/posts/${id}`, config)
      .then((res) => {
        setFeatureImage(res.data.meta.image_url_key);
      })
      .catch((err) => {
        console.log(err);
      });
    setShow(true);
  };
  const handleFeatureImageUpdate = (e) => {
    e.preventDefault();

    if (!featureImage) {
      toast.error("Please Chose One featured Image");
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        "Content-Type": "application/json",
      },
    };
    // `${API_BASE_URL}/wp-json/wp/v2/posts?status[]=publish&status[]=draft&author=${CurrentUserId}&per_page=100`
    axios
      .post(
        `${API_BASE_URL}/wp-json/wp/v2/posts/${updatePostId}`,
        {
          meta: {
            image_url_key: featureImage,
          },
        },
        config
      )
      .then((res) => {
        setFeatureImage(res.data.meta.image_url_key);
        setShow(false);
        toast.success("Image Uploaded Successfully");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // feature Image

  ////////////////DataTable data/////////////////////////////////////

  let articleData = apiResponse.map((e) => {
    // console.log("392e=", e)
    // console.log("403", allCategories)
    let cat =
      allCategories && allCategories.filter((c) => e.categories.includes(c.id));
    // console.log("404=", cat)
    // const fullString = cat[0] && cat[0].name;
    let fullString = "";

    for (let i = 0; i < cat.length; i++) {
      if (cat[i].parent == 0) {
        fullString = cat[i].name;
      }
    }

    let postAuthors = allUsers && allUsers.filter((c) => c.ID == e.author);

    // Use regular expression to extract value within parentheses
    const match = fullString?.match(/\(([^)]+)\)/);

    // Check if there is a match and extract the value
    let status = e.status == "draft" ? e.status : e.status + "ed";
    function toCapitalize(text) {
      return text?.charAt(0).toUpperCase() + text?.slice(1).toLowerCase();
    }
    //
    function changeDateFormat(originalDate) {
      // Parse the original date string
      const parsedDate = new Date(originalDate);

      // Extract the day, month, and year components
      const day = parsedDate.getDate().toString().padStart(2, "0");
      const month = (parsedDate.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
      const year = parsedDate.getFullYear();

      // Construct the new date format
      const newDateFormat = `${month}-${day}-${year}`;

      return newDateFormat;
    }

    // Example usage:
    const originalDate = e.date.slice(0, 10);
    const formattedDate = changeDateFormat(originalDate);

    //

    const epmValue = match ? match[1] : null;
    let obj = {
      id: e.id,
      title: toCapitalize(e.title.rendered),
      category: cat[0] && epmValue,
      date: formattedDate,
      status: toCapitalize(status),
      auhtor: toCapitalize(postAuthors[0]?.user_login),
      authorId: e.author,
      like: e.likes_count == "" ? 0 : e.likes_count,
      // status: <span className={`py-1 px-2  rounded  d-flex  justify-content-center mx-2 ${status == 'published' ? 'text-light' : 'text-dark'}`} style={{ backgroundColor: `${status == 'published' ? '#0d6efd' : '#ffc1077d'}` }}>{toCapitalize(status)}</span>
    };

    return obj;
  });

  useEffect(() => {
    let thead = document.querySelectorAll("th");

    for (let i = 0; i < thead.length; i++) {
      if (rolles == "administrator" || "author") {
        if (i == 0) {
          thead[i].style.cssText = `width:8%; `;
        }
        if (i === 1) {
          thead[i].style.cssText = `width:35%; `;
        }
      }
      // else {
      //   if (i === 0) {
      //     thead[i].style.cssText = `width:35%; `
      //   }
      // }
    }
  }, [articleData]);

  // console.log('ArticleData:', articleData)

  //
  let currentValue = [];
  let checkedCheckboxCount = [];
  const onchangeAuhtor = (e, current) => {
    const { id } = current;

    // setIsChecked(true)
    //

    if (e.target.checked) {
      setCheckedRows((prevCheckedRows) => [...prevCheckedRows, current.id]);
    } else {
      setCheckedRows((prevCheckedRows) =>
        prevCheckedRows.filter((id) => id !== current.id)
      );
    }

    //
    if (checkboxValue.some((value) => value.id === id)) {
      // If the current value is already in the array, remove it
      setCheckboxValue(checkboxValue.filter((value) => value.id !== id));
      checkedCheckboxCount = checkboxValue.filter((value) => value.id !== id);
    } else {
      // If the current value is not in the array, add it
      setCheckboxValue([...checkboxValue, current]);
      checkedCheckboxCount.push(current);
    }

    if (checkedCheckboxCount.length > 0) {
      setDisable(false);
    } else {
      setDisable(true);
    }

    console.log("476", checkboxValue);
  };

  const handleAuthorChange = (event) => {
    const selectedAuthorId = event.target.value;

    for (let i = 0; i < checkboxValue.length; i++) {
      currentValue.push({
        postId: 0,
        authorsId: 0,
      });
    }

    for (let i = 0; i < checkboxValue.length; i++) {
      currentValue[i].postId = checkboxValue[i].id;
      currentValue[i].authorsId = parseInt(selectedAuthorId);
    }

    setChangeAuthors(currentValue);
    console.log(currentValue);
    setSelectedAuthor(selectedAuthorId);
    console.log("Selected Author ID:", selectedAuthorId);
    console.log("checkboxvalue=", checkboxValue);
  };

  const transferAuthors = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        "Content-Type": "application/json",
      },
    };

    // if(changedAuthor)
    // console.log("481=", changedAuthors);
    if (changedAuthors.length == 0) {
      toast.error("Please select articles and author for article transfer.");
      return;
    }
    if (changedAuthors.postId == 0) {
      toast.error("Please select post  for transfer");
      return;
    }
    if (changedAuthors.authorsId == 0) {
      toast.error("Please select author for transfer");
      return;
    }
    console.log("line606=", changedAuthors);
    axios
      .post(
        `${API_BASE_URL}/wp-json/custom/v1/transfer-author`,
        changedAuthors,
        config
      )
      .then((res) => {
        console.log("line608=", res.data);
        if (res.data.length > 0) {
          setReload(reload ? false : true);
          toast.success("Article Transfer Succesfully");
          setNotificationCount(notificationCount + res.data.length);

          setDisable(true);
          setCheckboxValue([]);

          // notification api call start
          // let articles = [];
          // let author_name = ""
          for (let i = 0; i < res.data.length; i++) {
            // author_name = res.data[i].author_name;
            // articles.push(res.data[i].article_name)
            //
            let notification_count_specific_user = {
              user_id: res.data[i].author_id,
              count_value: res.data.count_value + 1,
            };

            if (notification_count_specific_user.user_id != "") {
              // post notification on usermeta start
              axios
                .post(
                  `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                  notification_count_specific_user,
                  config
                )
                .then((res) => {
                  console.log(res.data);
                })
                .catch((err) => {
                  console.log(err);
                });
            }

            //

            let notification_api_data = {
              author: localStorage.getItem("display_name"),
              articles: res.data[i].article_name,
              event_type: "Article Transferred",
              name: res.data[i].author_name,
              $author_ids: res.data[i].author_id,
              notification_ids: res.data[i].author_id,
              article_ids: res.data[i].article_id,
            };

            console.log("line652=", notification_api_data);

            axios
              .post(
                `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
                notification_api_data,
                config
              )
              .then((res) => {
                console.log(res.data);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          let articles_string = articles.join(",");

          // notification api call end
          // setIsChecked(false)
          setSelectedAuthor("");
          setChangeAuthors([]);
          setCheckedRows([]);
        } else {
          toast.error(res.data.message);
        }
        // setFeatureImage(res.data.guid.rendered)
      })
      .catch((err) => {
        console.log(err);
      });

    let notification_count = {
      user_id: "",
      count_value: notificationCount,
      reflect_count: "all_admin",
    };
    if (notification_count.user_id == "") {
      // post notification on usermeta start
      axios
        .post(
          `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
          notification_count,
          config
        )
        .then((res) => {
          console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    // axios.post(`${API_BASE_URL}/wp-json/custom/v1/transfer-author`, config, changedAuthors).then((res) => {
    //   console.log(res);
    //   toast.success("Authors Tranfers Succesfuly")
    // })
  };

  const bulkDelete = () => {
    if (checkboxValue.length == 0) {
      toast.error("Please select articles for delete.");
      // sd;
      return;
    } else {
      try {
        const confirmed = window.confirm(
          "Are you sure you want to delete this article?"
        );
        if (!confirmed) {
          return;
        }

        let postIds = [];
        for (let i = 0; i < checkboxValue.length; i++) {
          postIds.push(checkboxValue[i].id);
        }
        // const apiEndpoint = `${API_BASE_URL}/wp-json/wp/v2/posts/${checkboxValue[i].id}`;
        const apiEndpoint = `${API_BASE_URL}/wp-json/custom/v1/bulk-delete-articles`;
        console.log("line852=", postIds);
        // return;
        const config = {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
            "Content-Type": "application/json",
          },
          data: { post_ids: postIds },
        };

        axios
          .delete(apiEndpoint, config)
          .then((response) => {
            toast.success("Article Deleted Successfully", {
              toastId: "category",
            });

            const postData = {
              postId: response.data.id,
            };

            postIds.forEach((postId) => {
              axios
                .delete(
                  `${window.location.origin}/backend_cosmos/refresh/deletePost/${postId}`, // Using the postId in the URL
                  // You can pass postData if needed, just make sure to provide it correctly.
                  postData
                )
                .then((res) => {
                  console.log(`Post ${postId} deleted successfully:`, res);
                })
                .catch((err) => {
                  console.log(`Error deleting post ${postId}:`, err);
                  // Optionally, you can show a toast or notification
                  // toast.error("Article deleted successfully, but AI database not updated.");
                });
            });

            setReload(reload ? false : true);
          })
          .catch((error) => {
            console.log("Error deleting Enter Code data:", error);
          });
        // }
        setDisable(true);
        setCheckboxValue([]);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  //
  console.log("453=", changedAuthors);

  const data = useMemo(
    () => ({
      columns: [
        {
          label: "#",
          field: "checkbox",
          width: 50,
          sort: "disabled",
          fixedHeader: true,
        },
        {
          label: "Article Name",
          field: "title",
          width: 300,
          sort: "asc",
          fixedHeader: true,
        },
        {
          label: "Total Like",
          field: "like",
          width: 300,
          sort: "asc",
          fixedHeader: true,
        },
        {
          label: "Author",
          field: "auhtor",
          width: 300,
          sort: "asc",
          fixedHeader: true,
        },
        {
          label: "Date Created",
          field: "date",
          width: 100,
          fixed: true,
        },
        {
          label: "Category",
          field: "category",
          width: 300,
          fixed: true,
        },
        {
          label: "Status",
          field: "status",
          width: 100,
          fixed: true,
        },
        {
          label: "Action",
          field: "delete",
          sort: "disabled",
          width: 100,
          fixed: true,
        },
      ],
      rows: articleData.map((e) => {
        let current = e;
        // console.log("current=", current)
        return Object.assign(e, {
          delete: (
            <div className="d-flex justify-content-center">
              {/* <FaUserEdit
                data-toggle="tooltip"
                data-placement="bottom"
                title="Edit"
                onClick={() => handleEdit(current.id)}
                role="button"
                size={25}
                color="#0d6efd"
              /> */}
              <img
                data-toggle="tooltip"
                data-placement="bottom"
                title="Edit"
                role="button"
                onClick={() => handleEdit(current.id)}
                src={FaUserEdit}
                alt=""
              />
              {/* <MdDeleteForever
                data-toggle="tooltip"
                data-placement="bottom"
                title="Delete"
                onClick={() => handleDelete(current.id)}
                size={25}
                color="#0d6efd"
                role="button"
              /> */}
              <img
                className="mx-2"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Delete"
                role="button"
                onClick={() => handleDelete(current.id)}
                src={MdDeleteForever}
                alt=""
              />
              {/* <IoEye data-toggle="tooltip" data-placement="bottom" title="View" color='#0d6efd' role='button' size={25} onClick={() => gotToArticlePage(current.id)} /> */}
              {/* <FaImage data-toggle="tooltip" data-placement="bottom" title="Featured Image" color='#0d6efd' role='button' size={25} onClick={() => handleEditFeaturedImage(current.id)} /> */}
              <img
                className=""
                // height={30}
                onClick={() => handleEditFeaturedImage(current.id)}
                data-toggle="tooltip"
                data-placement="bottom"
                title="
              Edit featured image"
                role="button"
                src={EditFeatureImgage}
                alt=""
              />
            </div>
          ),
          checkbox: (
            <div>
              <input
                onChange={(e) => onchangeAuhtor(e, current)}
                type="checkbox"
                name=""
                id=""
                // checked={isChecked}

                checked={checkedRows.includes(current.id)}
              />
            </div>
          ),
        });
      }),
    }),
    [articleData, reload]
  );

  const data2 = useMemo(
    () => ({
      columns: [
        {
          label: "Article Name",
          field: "title",
          width: 300,
          sort: "asc",
          fixedHeader: true,
        },
        {
          label: "Total Like",
          field: "like",
          width: 300,
          sort: "asc",
          fixedHeader: true,
        },
        {
          label: "Author",
          field: "auhtor",
          width: 300,
          sort: "asc",
          fixedHeader: true,
        },
        {
          label: "Date Created",
          field: "date",
          width: 100,
          fixed: true,
        },
        {
          label: "Category",
          field: "category",
          width: 300,
          fixed: true,
        },
        {
          label: "Status",
          field: "status",
          width: 100,
          fixed: true,
        },
        {
          label: "Action",
          field: "delete",
          sort: "disabled",
          width: 100,
          fixed: true,
        },
      ],
      rows: articleData.map((e) => {
        let current = e;
        return Object.assign(e, {
          delete: (
            <div className="d-flex justify-content-center">
              {/* <FaUserEdit
                data-toggle="tooltip"
                data-placement="bottom"
                title="Edit"
                onClick={() => handleEdit(current.id)}
                role="button"
                size={25}
                color="#0d6efd"
              />{" "} */}
              <img
                data-toggle="tooltip"
                data-placement="bottom"
                title="Edit"
                role="button"
                onClick={() => handleEdit(current.id)}
                src={FaUserEdit}
                alt=""
              />
              {/* <MdDeleteForever
                data-toggle="tooltip"
                data-placement="bottom"
                title="Delete"
                onClick={() => handleDelete(current.id)}
                size={25}
                color="#0d6efd"
                role="button"
              /> */}
              <img
                className="mx-2"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Delete"
                role="button"
                onClick={() => handleDelete(current.id)}
                src={MdDeleteForever}
                alt=""
              />
              {/* <IoEye data-toggle="tooltip" data-placement="bottom" title="View" color='#0d6efd' role='button' size={25} onClick={() => gotToArticlePage(current.id)} /> */}
              {/* <FaImage data-toggle="tooltip" data-placement="bottom" title="Featured Image" color='#0d6efd' role='button' size={25} onClick={() => handleEditFeaturedImage(current.id)} /> */}
              <img
                className=""
                // height={30}
                onClick={() => handleEditFeaturedImage(current.id)}
                data-toggle="tooltip"
                data-placement="bottom"
                title="Edit featured image"
                role="button"
                src={EditFeatureImgage}
                alt=""
              />
            </div>
          ),
        });
      }),
    }),
    [articleData, reload]
  );

  ////////////////DataTable data end/////////////////////////////////

  // import doc start

  const handleFileChangeDocx = (event) => {
    // setFile(event.target.files[0]);
    // setFile(event.target.files);
    const selectedFiles = Array.from(event.target.files); // Get the selected files
    setFile(selectedFiles); // Update the state with selected files
    setmediaIds([]);
  };
  // const handleFileChangeDocxConvert = (event) => {
  //   // setFile(event.target.files[0]);
  //   // setFile(event.target.files);
  //   const selectedFiles = Array.from(event.target.files); // Get the selected files
  //   setFile(selectedFiles); // Update the state with selected files
  //   setmediaIds([]);
  // };
  function getVideoId(url) {
    // YouTube
    const youtubeMatch = url.match(
      /(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([^&\n?]+)/
    );
    if (youtubeMatch) {
      return youtubeMatch[1];
    }

    // Vimeo
    const vimeoMatch = url.match(
      /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:video\/)?(\d+)/
    );
    if (vimeoMatch) {
      return vimeoMatch[1];
    }

    // Wistia
    const wistiaMatch = url.match(
      /(?:https?:\/\/)?(?:www\.)?(\S*?)wistia\.com\/(?:medias\/)?(\w+)/
    );
    if (wistiaMatch) {
      return wistiaMatch[2];
    }

    return null;
  }

  // Handle delete action for a specific file
  const handleDeleteUploadFile = (fileIndex) => {
    // Remove the file at the specified index
    const updatedFiles = file.filter((_, index) => index !== fileIndex);

    // Update the file state with the new array
    setFile(updatedFiles);
    // setDeletedFiles((prev) => [...prev, fileIndex]); // Mark file as deleted
  };
  const handleUpload = async () => {
    if (!file) {
      toast.error("Select File to Upload");
      return;
    }

    // Check if the file type is .docx
    // if (
    //   file.type !==
    //   "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    // ) {
    //   toast.error("Invalid file type. Please upload a .docx file.");
    //   return;
    // }
    // const fileExtension = file.name.split(".").pop().toLowerCase();
    // if (
    //   fileExtension !== "docx" &&
    //   fileExtension !== "pptx" &&
    //   fileExtension !== "pdf"
    // ) {
    //   console.log(fileExtension);
    //   toast.error("Invalid file type. Please upload .docx, .pdf or .pptx file");
    //   return;
    // }
    setCreateArticle(true);
    setWordUpload(true);

    // create Iframe article start
    const config2 = {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        "Content-Type": "multipart/form-data",
      },
    };
    const formDataDoc = new FormData();
    formDataDoc.append("file", file);
    // formDataDoc.append("API_BASE_URL", API_BASE_URL);
    // formDataDoc.append("bearerToken", bearerToken);

    console.log("file1199=", file);
    return;
    // Step 1: Check if the post with the same title already exists
    const searchResponse = await fetch(
      `${API_BASE_URL}/wp-json/wp/v2/media?search=${encodeURIComponent(
        file.name
      )}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    const searchResults = await searchResponse.json();

    // Step 2: If a post with the same title exists, throw an error
    if (searchResults.length > 0) {
      console.log("Post with the same title already exists:", searchResults);
      toast.error("Same media file already exists!");
      setWordUpload(false);
      return;
    }
    // return;

    axios
      .post(`${API_BASE_URL}/wp-json/wp/v2/media`, formDataDoc, config2)
      .then((res) => {
        console.log("res1207", res.data);
        setPostTitle(res.data.title.rendered);

        let ArticleContent = `<iframe src="https://docs.google.com/viewer?url=${res.data.source_url}&embedded=true" width="100%" height="600"></iframe>`;
        setHtml(ArticleContent);
        setCreateArticle(true);
        //
        const fileSize = {
          file_size: res.data.media_details.filesize,
        };
        axios
          .post(`${API_BASE_URL}/wp-json/custom/v1/track-filesize`, fileSize, {
            headers: { Authorization: `Bearer ${bearerToken}` },
          })
          .then((response) => {
            console.log("Response data:", response.data);
            setAvailableSpace(
              Number(response.data.given_size) -
              Number(response.data.total_file_size_gb)
            );
            setTotalSpace(parseInt(response.data.given_size));
            setUsedSpace(Number(response.data.total_file_size_gb));
          })
          .catch((error) => {
            console.log("Error:", error);
          });

        //
      })
      .catch((err) => {
        console.log(err);
      });

    // create Iframe article end

    return;

    setPostTitle(file.name.split(".").slice(0, -1).join("."));
    const formData = new FormData();
    formData.append("file", file);
    formData.append("API_BASE_URL", API_BASE_URL);
    formData.append("bearerToken", bearerToken);
    console.log("1058line=", formData);
    console.log("Before try block");
    // alert(parseInt(TotalSpace) < parseInt(availableSpace));

    if (TotalSpace < availableSpace) {
      toast.error("Contact the administrator for more space.");
      // return;
    } else {
      try {
        console.log("Inside try block");
        const options = {
          styleMap: [
            "p[style-name='Heading 2'] => h2",
            "p[style-name= 'Heading 1'] => h1: fresh",
          ],
        };

        const htmlResult = await mammoth.convertToHtml(
          { arrayBuffer: await file.arrayBuffer() },
          options
        );

        let htmlContent = htmlResult.value;

        var parser = new DOMParser();
        var doc = parser.parseFromString(htmlContent, "text/html");

        var firstTagData = doc.body.children[0].innerHTML;
        console.log("776=", firstTagData);

        let $ = cheerio.load(htmlResult.value);

        $(
          "a:contains('https://youtu.be/'), a:contains('vimeo.com'), a:contains('wistia.com')"
        ).each((index, element) => {
          const videoLink = $(element).text();
          const videoId = getVideoId(videoLink);

          if (videoId) {
            if (videoLink.includes("youtu.be")) {
              const youtubeIframeCode = `<div> <iframe class="py-4 video-iframe" width="560" height="315" src="https://www.youtube.com/embed/${videoId}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> </div>`;
              $(element).replaceWith(youtubeIframeCode);
            } else if (videoLink.includes("vimeo.com")) {
              const vimeoIframeCode = `<div> <iframe class="py-4 video-iframe" src="https://player.vimeo.com/video/${videoId}" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> </div>`;
              $(element).replaceWith(vimeoIframeCode);
            } else if (videoLink.includes("wistia.com")) {
              const wistiaIframeCode = `<div> <iframe video-iframe class="py-4" src="https://fast.wistia.net/embed/iframe/${videoId}" width="640" height="360" frameborder="0" scrolling="no" allowtransparency="true" allowfullscreen></iframe> </div>`;
              $(element).replaceWith(wistiaIframeCode);
            }
          }
        });

        const uploadPromises = [];
        // if (parseInt(TotalSpace) > parseInt(availableSpace)) {
        $('img[src^="data:image"]').each((index, element) => {
          const base64Data = $(element).attr("src").split(",")[1];
          const decodedData = atob(base64Data);
          const byteNumbers = new Array(decodedData.length);
          for (let i = 0; i < decodedData.length; i++) {
            byteNumbers[i] = decodedData.charCodeAt(i);
          }
          const imageBuffer = new Uint8Array(byteNumbers);
          const extension = $(element).attr("src").split(";")[0].split("/")[1];
          const fileName = `image_${index}.${extension}`;

          const imageBlob = new Blob([imageBuffer], {
            type: `image/${extension}`,
          });
          console.log("elements1132=", fileName);
          // alert(fileName);
          const formData = new FormData();
          formData.append("file", imageBlob, fileName);

          uploadPromises.push(
            axios.post(`${API_BASE_URL}/wp-json/wp/v2/media`, formData, {
              headers: {
                Authorization: `Bearer ${bearerToken}`,
                "Content-Type": "multipart/form-data",
              },
            })
          );
        });
        // } else {
        //   toast.error("Contact the administrator for more space.");
        //   // return;
        // }

        const uploadResponses = await Promise.all(uploadPromises);

        $('img[src^="data:image"]').each((index, element) => {
          console.log("uploadResponses[index]", uploadResponses[index].data.id);
          // Set media IDs
          setmediaIds((prevMediaIds) => {
            const updatedMediaIds = [
              ...prevMediaIds,
              uploadResponses[index].data.id,
            ];
            return updatedMediaIds;
          });

          // The value of mediaIds here might still be the previous state
          console.log("Media IDs after setting:", mediaIds);
          const imageUrl = uploadResponses[index].data.source_url;
          $(element).attr("src", imageUrl);
          // track file size api call start
          const fileSize = {
            file_size: uploadResponses[index].data.media_details.filesize,
          };
          axios
            .post(
              `${API_BASE_URL}/wp-json/custom/v1/track-filesize`,
              fileSize,
              {
                headers: { Authorization: `Bearer ${bearerToken}` },
              }
            )
            .then((response) => {
              console.log("Response data:", response.data);
              setAvailableSpace(
                Number(response.data.given_size) -
                Number(response.data.total_file_size_gb)
              );
              setTotalSpace(parseInt(response.data.given_size));
              setUsedSpace(Number(response.data.total_file_size_gb));
            })
            .catch((error) => {
              console.log("Error:", error);
            });

          // track file size api call end
        });

        htmlContent = $.html();
        console.log("medaiId=", mediaIds);
        toast.success("Document uploaded successfully");

        setCreateArticle(true);
        setWordUpload(false);
        console.log("htmlContent=", htmlContent);
        setHtml(htmlContent);
      } catch (error) {
        setWordUpload(false);
        if (
          error.response &&
          error.response.data &&
          error.response.data.code === "rest_upload_unknown_error"
        ) {
          toast.error(
            "Upload failed: The imported Word document contains invalid file type. Please remove it and try uploading the file again."
          );
        } else {
          toast.error("Error uploading file");
        }
        console.error("Error uploading file:", error);
      }
    }
    console.log("After try-catch block");
  };
  const handleUploadWord = async () => {
    if (!file) {
      toast.error("Select File to Upload");
      return;
    }
    // setIsUploading(true)
    // setModalShow(false);
    setWordUpload(true);
    console.log("file=", file);

    setPostTitle(file[0].name.split(".").slice(0, -1).join("."));
    const formData = new FormData();
    formData.append("file", file[0]);
    formData.append("API_BASE_URL", API_BASE_URL);
    formData.append("bearerToken", bearerToken);

    try {
      const options = {
        styleMap: [
          // "p[style-name='Heading 1'] => h1.centered", // Add a custom class for centering
          "p[style-name='Heading 2'] => h2",
          "p[style-name= 'Heading 1'] => h1: fresh",
          // Add more mappings as needed
        ],
      };
      // mammoth.convertToHtml({ path: "path/to/document.docx" }, options);
      const htmlResult = await mammoth.convertToHtml(
        {
          arrayBuffer: await file[0].arrayBuffer(),
        },
        options
      );
      console.log("htmlhtmlResult767=", htmlResult);
      let htmlContent = htmlResult.value;
      console.log("htmlContent767=", htmlContent);

      // Parsing the HTML content
      var parser = new DOMParser();
      var doc = parser.parseFromString(htmlContent, "text/html");

      // Extracting the data within the first HTML tag
      var firstTagData = doc.body.children[0].innerHTML;

      console.log("776=", firstTagData);
      // setPostTitle(firstTagData)

      let $ = cheerio.load(htmlResult.value);

      // Find and replace YouTube links with iframes
      $(
        "a:contains('https://youtu.be/'), a:contains('vimeo.com'), a:contains('wistia.com')"
      ).each((index, element) => {
        const videoLink = $(element).text();
        // console.log("videoLink824=", videoLink);
        const videoId = getVideoId(videoLink);
        // console.log("videoId826=", videoId)
        if (videoId) {
          if (videoLink.includes("youtu.be")) {
            const youtubeIframeCode = `<div> <iframe class="py-4 video-iframe" width="560" height="315" src="https://www.youtube.com/embed/${videoId}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> </div>`;
            $(element).replaceWith(youtubeIframeCode);
          } else if (videoLink.includes("vimeo.com")) {
            const vimeoIframeCode = `<div> <iframe class="py-4 video-iframe" src="https://player.vimeo.com/video/${videoId}" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> </div>`;
            // console.log("vimeo832=", vimeoIframeCode)
            $(element).replaceWith(vimeoIframeCode);
          } else if (videoLink.includes("wistia.com")) {
            const wistiaIframeCode = `<div> <iframe video-iframe class="py-4" src="https://fast.wistia.net/embed/iframe/${videoId}" width="640" height="360" frameborder="0" scrolling="no" allowtransparency="true" allowfullscreen></iframe> </div>`;
            $(element).replaceWith(wistiaIframeCode);
          }
        }
      });

      const uploadPromises = [];

      // Convert base64 images to external URLs
      $('img[src^="data:image"]').each((index, element) => {
        const base64Data = $(element).attr("src").split(",")[1];
        const decodedData = atob(base64Data);
        const byteNumbers = new Array(decodedData.length);
        for (let i = 0; i < decodedData.length; i++) {
          byteNumbers[i] = decodedData.charCodeAt(i);
        }
        const imageBuffer = new Uint8Array(byteNumbers);
        const extension = $(element).attr("src").split(";")[0].split("/")[1];
        const fileName = `image_${index}.${extension}`;

        // Create a Blob from the imageBuffer
        const imageBlob = new Blob([imageBuffer], {
          type: `image/${extension}`,
        });

        const formData = new FormData();
        formData.append("file", imageBlob, fileName);

        // Push the promise of image upload to the array
        uploadPromises.push(
          axios.post(`${API_BASE_URL}/wp-json/wp/v2/media`, formData, {
            headers: {
              Authorization: `Bearer ${bearerToken}`,
              "Content-Type": "multipart/form-data",
            },
          })
        );
      });

      // Wait for all image uploads to complete
      const uploadResponses = await Promise.all(uploadPromises);

      // Update HTML with image URLs
      $('img[src^="data:image"]').each((index, element) => {
        const imageUrl = uploadResponses[index].data.source_url;
        $(element).attr("src", imageUrl);
      });

      htmlContent = $.html();
      // setIsUploading(false)
      toast.success("Document uploaded successfully");
      setCreateArticle(true);

      setWordUpload(false);
      console.log("htmlContent=", htmlContent);

      setHtml(htmlContent);

      return;
      const response = await axios.post(
        "https://silfratech.in/krbackend-api/extract",
        formData
      );
      setHtml(response.data.htmlContent);
      console.log(response.data.htmlContent);
    } catch (error) {
      setWordUpload(false);
      toast.error("Error uploading file");
      console.error("Error uploading file:", error);
    }
  };
  // Use useEffect to log the updated mediaIds
  useEffect(() => {
    console.log("Updated media IDs:", mediaIds);
  }, [mediaIds]);
  // const handleUpload = async () => {
  //   if (!file) {
  //     toast.error("Select File to Upload");
  //     return;
  //   }
  //   // setIsUploading(true)
  //   // setModalShow(false);
  //   setWordUpload(true);
  //   console.log("file=", file);

  //   setPostTitle(file.name.split(".").slice(0, -1).join("."));
  //   const formData = new FormData();
  //   formData.append("file", file);
  //   formData.append("API_BASE_URL", API_BASE_URL);
  //   formData.append("bearerToken", bearerToken);
  //   console.log("1058line=", formData);
  //   console.log("Before try block");
  //   try {
  //     console.log("Inside try block");
  //     const options = {
  //       styleMap: [
  //         // "p[style-name='Heading 1'] => h1.centered", // Add a custom class for centering
  //         "p[style-name='Heading 2'] => h2",
  //         "p[style-name= 'Heading 1'] => h1: fresh",
  //         // Add more mappings as needed
  //       ],
  //     };
  //     // mammoth.convertToHtml({ path: "path/to/document.docx" }, options);
  //     const htmlResult = await mammoth.convertToHtml(
  //       {
  //         arrayBuffer: await file.arrayBuffer(),
  //       },
  //       options
  //     );

  //     let htmlContent = htmlResult.value;

  //     // Parsing the HTML content
  //     var parser = new DOMParser();
  //     var doc = parser.parseFromString(htmlContent, "text/html");

  //     // Extracting the data within the first HTML tag
  //     var firstTagData = doc.body.children[0].innerHTML;

  //     console.log("776=", firstTagData);
  //     // setPostTitle(firstTagData)

  //     let $ = cheerio.load(htmlResult.value);

  //     // Find and replace YouTube links with iframes
  //     $(
  //       "a:contains('https://youtu.be/'), a:contains('vimeo.com'), a:contains('wistia.com')"
  //     ).each((index, element) => {
  //       const videoLink = $(element).text();
  //       // console.log("videoLink824=", videoLink);
  //       const videoId = getVideoId(videoLink);
  //       // console.log("videoId826=", videoId)
  //       if (videoId) {
  //         if (videoLink.includes("youtu.be")) {
  //           const youtubeIframeCode = `<div> <iframe class="py-4 video-iframe" width="560" height="315" src="https://www.youtube.com/embed/${videoId}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> </div>`;
  //           $(element).replaceWith(youtubeIframeCode);
  //         } else if (videoLink.includes("vimeo.com")) {
  //           const vimeoIframeCode = `<div> <iframe class="py-4 video-iframe" src="https://player.vimeo.com/video/${videoId}" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> </div>`;
  //           // console.log("vimeo832=", vimeoIframeCode)
  //           $(element).replaceWith(vimeoIframeCode);
  //         } else if (videoLink.includes("wistia.com")) {
  //           const wistiaIframeCode = `<div> <iframe video-iframe class="py-4" src="https://fast.wistia.net/embed/iframe/${videoId}" width="640" height="360" frameborder="0" scrolling="no" allowtransparency="true" allowfullscreen></iframe> </div>`;
  //           $(element).replaceWith(wistiaIframeCode);
  //         }
  //       }
  //     });

  //     const uploadPromises = [];

  //     // Convert base64 images to external URLs
  //     $('img[src^="data:image"]').each((index, element) => {
  //       const base64Data = $(element).attr("src").split(",")[1];
  //       const decodedData = atob(base64Data);
  //       const byteNumbers = new Array(decodedData.length);
  //       for (let i = 0; i < decodedData.length; i++) {
  //         byteNumbers[i] = decodedData.charCodeAt(i);
  //       }
  //       const imageBuffer = new Uint8Array(byteNumbers);
  //       const extension = $(element).attr("src").split(";")[0].split("/")[1];
  //       const fileName = `image_${index}.${extension}`;
  //       // alert(fileName);
  //       // Create a Blob from the imageBuffer
  //       const imageBlob = new Blob([imageBuffer], {
  //         type: `image/${extension}`,
  //       });

  //       const formData = new FormData();
  //       formData.append("file", imageBlob, fileName);

  //       // Push the promise of image upload to the array
  //       uploadPromises.push(
  //         axios.post(`${API_BASE_URL}/wp-json/wp/v2/media`, formData, {
  //           headers: {
  //             Authorization: `Bearer ${bearerToken}`,
  //             "Content-Type": "multipart/form-data",
  //           },
  //         })
  //       );
  //     });

  //     // Wait for all image uploads to complete
  //     const uploadResponses = await Promise.all(uploadPromises);

  //     // Update HTML with image URLs
  //     $('img[src^="data:image"]').each((index, element) => {
  //       const imageUrl = uploadResponses[index].data.source_url;
  //       $(element).attr("src", imageUrl);
  //     });

  //     htmlContent = $.html();
  //     // setIsUploading(false)
  //     toast.success("Document uploaded successfully");
  //     setCreateArticle(true);

  //     setWordUpload(false);
  //     console.log("htmlContent=", htmlContent);

  //     setHtml(htmlContent);

  //     return;
  //     const response = await axios.post(
  //       "https://silfratech.in/krbackend-api/extract",
  //       formData
  //     );
  //     setHtml(response.data.htmlContent);
  //     console.log(response.data.htmlContent);
  //   } catch (error) {
  //     setWordUpload(false);
  //     // alert("fdfgdg");
  //     toast.error("Error uploading file");
  //     console.error("Error uploading file:", error);
  //   }
  // };

  const handleCloseModal = () => {
    setModalShow(false);
    setSelectedAuthor(localStorage.getItem("current_user_Id"));
    setModalShowWordDoc(false)

    setCreateArticle(false);
    setWordUpload(false);
  };
  const onpenModal = () => {
    setSelectedAuthor(localStorage.getItem("current_user_Id"));
    setModalShow(true);
    setWordUpload(false);
  };
  const CreateArticle = async () => {
    if (file.length <= 0) {
      toast.error("Select File to Upload");
      return;
    }
    setIsUploading(true); // Set to true when uploading starts
    let currentProgress = 0; // Start progress from 0
    setUploadProgress(0);
    console.log("line1583=", file);
    const totalFiles = file.length; // Total number of files/posts
    setFileFraction(`0/${totalFiles}`); // Set initial fraction value (0/x)

    // 24-10-24 start
    const formData = new FormData();
    const mediaIds = []; // Initialize media IDs array
    let allPostsCreated = true;
    // alert()
    if (categoryLength > 0) {
      try {
        // Loop through all selected files and upload each
        // Initialize total files and progress before the loop
        // const totalFiles = file.length;
        // let currentProgress = 0;

        for (let i = 0; i < totalFiles; i++) {
          // Check for duplicate files
          const searchResponse = await fetch(
            `${API_BASE_URL}/wp-json/wp/v2/media?search=${encodeURIComponent(
              file[i].name
            )}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${bearerToken}`,
                "Content-Type": "application/json",
              },
            }
          );

          const searchResults = await searchResponse.json();

          // Skip if a duplicate file is found
          if (searchResults.length > 0) {
            toast.warn(`Duplicate file found: ${file[i].name}, skipping...`);
            continue;
          }

          // Initialize FormData and add the file
          const formData = new FormData();
          formData.append("file", file[i]);

          // Upload file to WordPress media library
          const fileUploadResponse = await axios.post(
            `${API_BASE_URL}/wp-json/wp/v2/media`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${bearerToken}`,
              },
            }
          );

          // Store the uploaded media ID
          mediaIds.push(fileUploadResponse.data.id);

          const fileUrl = fileUploadResponse.data.source_url;
          const fileSize = {
            file_size: fileUploadResponse.data.media_details.filesize,
          };

          // Track file size using custom endpoint
          try {
            const sizeTrackingResponse = await axios.post(
              `${API_BASE_URL}/wp-json/custom/v1/track-filesize`,
              fileSize,
              { headers: { Authorization: `Bearer ${bearerToken}` } }
            );

            setAvailableSpace(
              Number(sizeTrackingResponse.data.given_size) -
              Number(sizeTrackingResponse.data.total_file_size_gb)
            );
            setTotalSpace(parseInt(sizeTrackingResponse.data.given_size));
            setUsedSpace(Number(sizeTrackingResponse.data.total_file_size_gb));
          } catch (error) {
            console.log("Error while tracking file size:", error);
          }
          let fileContent = "";
          if (fileUrl.toLowerCase().endsWith(".pdf")) {
            console.log("PDF URL:", fileUrl);
            fileContent = `<p><a class="pdf-view" href="${fileUrl}" target="_blank" width="100%" height="600">${file[i].name.replace(/\.pdf$/, "")}</a> </p>`;
          } else {
            fileContent = `<iframe  src="https://docs.google.com/viewer?url=${fileUrl}&embedded=true" width="100%" height="600"></iframe>`;
          }
          // Create WordPress post
          setUploadingFileName(file[i].name);
          const postResponse = await axios.post(
            `${API_BASE_URL}/wp-json/wp/v2/posts`,
            {
              title: file[i].name,
              // content: `<iframe src="https://docs.google.com/viewer?url=${fileUrl}&embedded=true" width="100%" height="600"></iframe>`,
              content: fileContent,
              status: "publish",
              meta: { media_ids: mediaIds },
              author:
                selectedAuthor === ""
                  ? localStorage.getItem("current_user_Id")
                  : selectedAuthor,
            },
            {
              headers: {
                Authorization: `Bearer ${bearerToken}`,
                "Content-Type": "application/json",
              },
            }
          );

          const createdPost = postResponse.data;

          try {
            // Call the external /createPost API
            const postData = { post: createdPost };
            const externalPostResponse = await axios.post(
              // `https://krstaging.camptratech.com/backend_cosmos/refresh/createPost`,
              `${window.location.origin}/backend_cosmos/refresh/createPost`,
              postData
            );

            console.log(
              "Backend createPost response:",
              externalPostResponse.data
            );

            // Send email notification after post creation
            const responseEmail = await fetch(
              `${API_BASE_URL}/wp-json/myplugin/v1/send-email/`,
              {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${bearerToken}`,
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  author_id: createdPost.author,
                  post_id: createdPost.id,
                }),
              }
            );

            const emailData = await responseEmail.json();
            console.log("Email sent response:", emailData);

            console.log("Post created successfully:", createdPost);
          } catch (error) {
            console.error("Error during /createPost API call:", error);

            // Delete the WordPress post if external API fails
            try {
              await axios.delete(
                `${API_BASE_URL}/wp-json/custom/v1/delete-article?post_id=${createdPost.id}`,
                {
                  headers: {
                    Authorization: `Bearer ${bearerToken}`,
                    "Content-Type": "application/json",
                  },
                }
              );
              toast.error("Failed to complete the process. Post deleted.");
              setModalShow(false);
              setCreateArticle(false);
            } catch (deleteError) {
              console.log("Error while deleting the post:", deleteError);
            }
          }

          // Update progress after each successful post creation
          currentProgress = ((i + 1) / totalFiles) * 100;
          setUploadProgress(currentProgress);
          setFileFraction(`${i + 1}/${totalFiles}`);
        }

        // Check if all posts were created successfully
        toast.success("Articles Created created successfully.");
        setModalShow(false);
        // toast.success("Article Created Successfully");
        setReload(!reload); // Toggle reload state
        setCreateArticle(false);
        setSelectedAuthor("");
        setIsUploading(false); // Set to false when upload finishes
      } catch (error) {
        console.error("Error uploading files and creating posts:", error);
        toast.error("An error occurred while creating posts.");
        setIsUploading(false); // Set to false if there's an error
      }
    } else {
      toast.error("First create one category then create articles.");
    }
    // };

    // Add the new post to the state to display
    // setUploadedPosts((prevPosts) => [
    //   ...prevPosts,
    //   { id: postResponse.data.id, link: postResponse.data.link },
    // ]);
    // }
    // setError(null); // Clear any previous error
    // } catch (err) {
    //   console.log(err);
    // }
    // };
    // 24-10-24 end
    return;

    try {
      // const authorId = await findAuthorId();
      let bodyData;
      if (selectedAuthor !== "") {
        bodyData = JSON.stringify({
          title: postTitle,
          content: html,
          meta: {
            media_ids: mediaIds, // Storing media IDs in post meta
          },
          status: "publish",
          // date: postDate,
          author: selectedAuthor,
          // Add any other post parameters as needed
        });
      } else {
        bodyData = JSON.stringify({
          title: postTitle,
          content: html,
          status: "publish",
          meta: {
            media_ids: mediaIds, // Storing media IDs in post meta
          },
          // date: postDate,
          author: localStorage.getItem("current_user_Id"),
          // Add any other post parameters as needed
        });
      }

      // if (selectedAuthor !== null) {
      //   //

      //   const response = await fetch(`${API_BASE_URL}/wp-json/wp/v2/posts`, {
      //     method: "POST",
      //     headers: {
      //       Authorization: `Bearer ${bearerToken}`,
      //       "Content-Type": "application/json",
      //       // Add any additional headers or authentication tokens if required
      //     },

      //     // body: JSON.stringify({
      //     //   title: "",
      //     //   content: html,
      //     //   // date: postDate,
      //     //   author: selectedAuthor,
      //     //   // Add any other post parameters as needed
      //     // }),
      //     body: bodyData,
      //   });

      //   const createdPost = await response.json();
      //   console.log("createdPost=", createdPost);

      //   //email send start

      //   const responseEamil = await fetch(
      //     `${API_BASE_URL}/wp-json/myplugin/v1/send-email/`,
      //     {
      //       method: "POST",
      //       headers: {
      //         Authorization: `Bearer ${bearerToken}`,
      //         "Content-Type": "application/json",
      //         // Add any additional headers or authentication tokens if required
      //       },
      //       body: JSON.stringify({
      //         author_id: createdPost.author,
      //         post_id: createdPost.id,
      //       }),
      //     }
      //   );
      //   const emailData = await responseEamil.json();
      //   console.log("emailData=", emailData);

      //   // email send end
      //   setModalShow(false);

      //   // if()
      //   toast.success("Article Created Successfully");
      //   setReload(reload ? false : true);
      //   setCreateArticle(false);
      //   // setAuthors(0)
      //   setSelectedAuthor("");
      //   console.log("Post created successfully:", response);
      // }
      // if (selectedAuthor !== null) {
      //   const postData = {
      //     post: bodyData,
      //   };
      //   //
      //   axios
      //     .post(
      //       // `${window.location.origin}/backend_cosmos/refresh/createPost`,
      //       `https://krstaging.camptratech.com/backend_cosmos/refresh/createPost`,
      //       postData
      //     )
      //     .then(async (res) => {
      //       console.log("line364=", res);

      //       // Make the WordPress post creation request
      //       const response = await fetch(
      //         `${API_BASE_URL}/wp-json/wp/v2/posts`,
      //         {
      //           method: "POST",
      //           headers: {
      //             Authorization: `Bearer ${bearerToken}`,
      //             "Content-Type": "application/json",
      //             // Add any additional headers or authentication tokens if required
      //           },
      //           body: JSON.stringify(bodyData), // Ensure bodyData is in JSON string format
      //         }
      //       );

      //       const createdPost = await response.json();
      //       console.log("createdPost=", createdPost);

      //       // Send email after post is created
      //       const responseEmail = await fetch(
      //         `${API_BASE_URL}/wp-json/myplugin/v1/send-email/`,
      //         {
      //           method: "POST",
      //           headers: {
      //             Authorization: `Bearer ${bearerToken}`,
      //             "Content-Type": "application/json",
      //           },
      //           body: JSON.stringify({
      //             author_id: createdPost.author,
      //             post_id: createdPost.id,
      //           }),
      //         }
      //       );
      //       const emailData = await responseEmail.json();
      //       console.log("emailData=", emailData);

      //       // Email sent, handle UI updates
      //       setModalShow(false);
      //       toast.success("Article Created Successfully");
      //       setReload(!reload); // Toggle reload state
      //       setCreateArticle(false);
      //       setSelectedAuthor("");

      //       console.log("Post created successfully:", createdPost);
      //     })
      //     .catch((error) => {
      //       console.error("Error during post creation:", error);
      //       // Handle error appropriately, maybe show a toast or alert
      //     });
      // }

      if (selectedAuthor !== null) {
        try {
          // First, create a WordPress post using the /wp-json/wp/v2/posts API
          const response = await fetch(`${API_BASE_URL}/wp-json/wp/v2/posts`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${bearerToken}`,
              "Content-Type": "application/json",
              // Add any additional headers or authentication tokens if required
            },
            // body: JSON.stringify({
            //   title: "",
            //   content: html,
            //   // date: postDate,
            //   author: selectedAuthor,
            //   // Add any other post parameters as needed
            // }),
            body: bodyData,
            // }); // Ensure bodyData is in JSON string format
          });

          // Parse the response to get the created post data
          const createdPost = await response.json();
          console.log("createdPost=", createdPost);
          const postData = {
            post: createdPost,
          };
          // Now that the WordPress post is created, call the /createPost API
          axios
            .post(
              `${window.location.origin}/backend_cosmos/refresh/createPost`,
              // `https://krstaging.camptratech.com/backend_cosmos/refresh/createPost`,
              postData
            )
            .then(async (res) => {
              console.log("line364= Backend createPost response:", res);

              // After successfully calling /createPost, send an email
              const responseEmail = await fetch(
                `${API_BASE_URL}/wp-json/myplugin/v1/send-email/`,
                {
                  method: "POST",
                  headers: {
                    Authorization: `Bearer ${bearerToken}`,
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    author_id: createdPost.author,
                    post_id: createdPost.id,
                  }),
                }
              );
              const emailData = await responseEmail.json();
              console.log("emailData=", emailData);

              // Update the UI after everything is completed
              setModalShow(false);
              toast.success("Article Created Successfully");
              setReload(!reload); // Toggle reload state
              setCreateArticle(false);
              setSelectedAuthor("");

              console.log("Post created successfully:", createdPost);
            })
            .catch((error) => {
              //

              // const apiEndpoint = `${API_BASE_URL}/wp-json/wp/v2/posts/${id}`;
              const apiEndpoint = `${API_BASE_URL}/wp-json/custom/v1/delete-article?post_id=${createdPost.id}`;

              const config = {
                headers: {
                  Authorization: `Bearer ${bearerToken}`,
                  "Content-Type": "application/json",
                },
              };

              axios
                .delete(apiEndpoint, config)
                .then((response) => {
                  console.log(response);
                  setCreateArticle(false);
                  setModalShow(false);
                  toast.error("Error during /createPost API call:");
                })
                .catch((err) => {
                  console.log(err);
                });
              //

              console.error("Error during /createPost API call:", error);
            });
        } catch (error) {
          console.error(
            "Error during WordPress post creation or email sending:",
            error
          );
          // Handle error appropriately, maybe show a toast or alert
        }
      } else {
        console.error("Unable to determine author");
      }
    } catch (error) {
      toast.error("Error creating post");
      console.error("Error creating post:", error);
    }
  };

  const CreateArticleWord = async () => {
    try {
      // const authorId = await findAuthorId();
      let bodyData;
      if (selectedAuthor !== "") {
        bodyData = JSON.stringify({
          title: postTitle,
          content: html,
          // date: postDate,
          author: selectedAuthor,
          // Add any other post parameters as needed
        });
      } else {
        bodyData = JSON.stringify({
          title: postTitle,
          content: html,
          // date: postDate,
          author: localStorage.getItem("current_user_Id"),
          // Add any other post parameters as needed
        });
      }
      if (selectedAuthor !== null) {
        const response = await fetch(`${API_BASE_URL}/wp-json/wp/v2/posts`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${bearerToken}`,
            "Content-Type": "application/json",
            // Add any additional headers or authentication tokens if required
          },

          // body: JSON.stringify({
          //   title: "",
          //   content: html,
          //   // date: postDate,
          //   author: selectedAuthor,
          //   // Add any other post parameters as needed
          // }),
          body: bodyData,
        });

        const createdPost = await response.json();
        console.log("createdPost=", createdPost);

        //email send start

        const responseEamil = await fetch(
          `${API_BASE_URL}/wp-json/myplugin/v1/send-email/`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${bearerToken}`,
              "Content-Type": "application/json",
              // Add any additional headers or authentication tokens if required
            },
            body: JSON.stringify({
              author_id: createdPost.author,
              post_id: createdPost.id,
            }),
          }
        );
        const emailData = await responseEamil.json();
        console.log("emailData=", emailData);

        // email send end
        setModalShowWordDoc(false);

        // if()
        toast.success("Article Created Successfully");
        setReload(reload ? false : true);
        setCreateArticle(false);
        // setAuthors(0)
        setSelectedAuthor("");
        console.log("Post created successfully:", response);
      } else {
        console.error("Unable to determine author");
      }
    } catch (error) {
      toast.error("Error creating post");
      console.error("Error creating post:", error);
    }
  };
  // import doc end

  return (
    <div>
      <div className="row g-0">
        <div
          style={{ minHeight: "90vh" }}
          className={
            collaps ? "column right-column  col" : "column right-column  col "
          }
        >
          {/* <!-- Content for the right column goes here --> */}
          <div className="w-100">
            <NewTopNavBar />
          </div>

          {/* feature Image modal */}
          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>Featured Image</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row g-0 w-100 ">
                <form className="">
                  {/* <<<<<<< HEAD
                  <div className="form-group">
                    <label for="exampleInputEmail1">Featured Image:</label>
                    <br />
                    <img className='py-2' height={200} width={200} src={featureImage */}
                  {/* // ======= */}
                  {featuredImageLoading ? (
                    <div
                      className="form-group d-flex justify-content-center my-4 "
                      style={{ minHeight: "160px" }}
                    >
                      {" "}
                      <Spinner />
                    </div>
                  ) : (
                    <div className="form-group d-flex justify-content-center my-4">
                      {/* <label for="exampleInputEmail1">Featured Image:</label> */}
                      <img
                        height={200}
                        width={400}
                        src={
                          featureImage
                          // >>>>>>> 798b7f3b4ebf0a6bbd95ffe202d137ef44a61afa
                        }
                        alt=""
                      />
                    </div>
                  )}

                  <div className="form-group ">
                    <label className="fw-bold">Update Featued Image:</label>
                    {/* <div className='upload-users-section input-group'> */}
                    <div className="d-flex align-items-center">
                      <input
                        className="form-control my-2 W-75"
                        type="file"
                        accept="image/*"
                        id="file"
                        label="Choose image upload"
                        onChange={handleFileChange}
                      />
                      <img
                        className="ms-2"
                        // width={40}
                        onClick={handleFeatureImageUpdate}
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Upload"
                        role="button"
                        src={UploadImage}
                        alt=""
                      />
                    </div>
                  </div>

                  <div className="text-end">
                    {/* {featuredImageLoading ? <button type='submit' className='input-group btn  btn-primary m-0'
                      // style={{ backgroundColor: 'rgb(18, 178, 142)', color: "white" }}

                      onClick={handleFeatureImageUpdate} disabled
                    >
                      Upload
                    </button> : <button type='submit' className='input-group btn  btn-primary m-0'
                      // style={{ backgroundColor: 'rgb(18, 178, 142)', color: "white" }}

                      onClick={handleFeatureImageUpdate}
                    >
                      Upload
                    </button>} */}
                    {/* <img className='ms-2' height={40} onClick={handleFeatureImageUpdate} data-toggle="tooltip" data-placement="bottom" title="Upload" role='button' src={UploadImage} alt="" /> */}
                  </div>
                </form>
              </div>
            </Modal.Body>
            <Modal.Footer>
              {/* <Button variant="secondary" onClick={handleClose}>
                          Close
                        </Button> */}
              {/* <Button variant="primary" onClick={handleSubmitCreateUsers}>
                Create User
              </Button> */}
            </Modal.Footer>
          </Modal>

          {/* feature Image modal */}

          {/* upload word doc modal start */}
          <Modal show={modalShow} onHide={handleCloseModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>Upload Document</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row g-0 w-100 ">
                <div className="col-3"></div>
                <div className="col-12">
                  {/* <form onClick={(e) => e.preventDefault()}> */}
                  <div className="form-group">
                    <div className=" mb-2">
                      <input
                        className="p-1 form-control "
                        type="file"
                        accept=".pdf, .pptx, .docx"
                        multiple
                        onChange={(e) => handleFileChangeDocx(e)}
                      // disabled={wordUpload ? true : false}
                      />
                      <div className="text-end mt-2">
                        {/* <button
                          className="btn btn-primary  my-0"
                          onClick={() => handleUpload()}
                          disabled={wordUpload ? true : false}
                        >
                          {wordUpload ? "Uploading" : "Upload"}
                        </button> */}
                        <img
                          data-toggle="tooltip"
                          data-placement="bottom"
                          type="button"
                          onClick={() => handleUpload()}
                          disabled={wordUpload ? true : false}
                          // width={50}
                          title="Upload document"
                          src={WordUploadImg}
                          alt=""
                        />
                      </div>
                      {console.log(file)}
                      {createArticle ? (
                        <div>
                          {/*  */}

                          {file.length > 0 && (
                            <div>
                              <h5>Files being uploaded:</h5>
                              <ul>
                                {file.map((f, index) => (
                                  <li key={index}>
                                    {f.name}{" "}
                                    {/* {!deletedFiles.includes(index) && ( */}
                                    <img
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      type="button"
                                      title="Cancel"
                                      src={cancelArticles}
                                      className="ps-1"
                                      alt=""
                                      onClick={() =>
                                        handleDeleteUploadFile(index)
                                      }
                                    />
                                    {/* <button
                                      onClick={() =>
                                        handleDeleteUploadFile(index)
                                      }
                                    >
                                      Delete
                                    </button> */}
                                    {/* )} */}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                          {/*  */}
                          <div className="pt-2">
                            <select
                              className="w-100"
                              id="categorySelect"
                              onChange={handleAuthorChange}
                              value={selectedAuthor}
                            >
                              <option value="0">Select an author</option>
                              {authors.map((author) => (
                                <option key={author.ID} value={author.ID}>
                                  {author.user_login}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="text-end mt-2">
                            {/* <button onClick={CreateArticle} className='btn btn-primary'>Import Article</button> */}
                            <img
                              data-toggle="tooltip"
                              data-placement="bottom"
                              type="button"
                              onClick={() => CreateArticle()}
                              // disabled={wordUpload ? true : false}
                              // width={40}
                              title="Import Article"
                              src={ImportArticleImage}
                              alt=""
                            />
                          </div>

                          {isUploading && (
                            <div>
                              {/* 
                              <ProgressBar
                                now={uploadProgress}
                                label={`${uploadProgress}%`}
                              />
                              */}
                              <ProgressBar
                                now={uploadProgress}
                                label={`${fileFraction} (${Math.round(
                                  uploadProgress
                                )}%)`} // Display both fraction and percentage
                              />
                              <div>Uploading File:{uploadingFileName}</div>
                              <div>{fileFraction} uploaded</div>
                            </div>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* </form> */}
                  </div>
                  <div className="col-3"></div>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          {/* upload word doc modal end */}


          {/* upload word doc modal convert start */}
          <Modal show={modalShowWordDoc} onHide={handleCloseModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>Upload Document </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row g-0 w-100 ">
                <div className="col-3"></div>
                <div className="col-12">
                  {/* <form onClick={(e) => e.preventDefault()}> */}
                  <div className="form-group">
                    <div className=" mb-2">
                      <input
                        className="p-1 form-control "
                        type="file"
                        accept=".docx"
                        // multiple
                        onChange={(e) => handleFileChangeDocx(e)}
                      // disabled={wordUpload ? true : false}
                      />
                      <div className="text-end mt-2">
                        {/* <button
                          className="btn btn-primary  my-0"
                          onClick={() => handleUpload()}
                          disabled={wordUpload ? true : false}
                        >
                          {wordUpload ? "Uploading" : "Upload"}
                        </button> */}
                        <img
                          data-toggle="tooltip"
                          data-placement="bottom"
                          type="button"
                          onClick={() => handleUploadWord()}
                          disabled={wordUpload ? true : false}
                          // width={50}

                          title="Upload document"
                          src={WordUploadImg}
                          alt=""
                        />
                      </div>
                      {console.log(file)}
                      {createArticle ? (
                        <div>
                          {/*  */}

                          {/* {file.length > 0 && ( */}

                          {/*  */}
                          <div className="pt-2">
                            <select
                              className="w-100"
                              id="categorySelect"
                              onChange={handleAuthorChange}
                              value={selectedAuthor}
                            >
                              <option value="0">Select an author</option>
                              {authors.map((author) => (
                                <option key={author.ID} value={author.ID}>
                                  {author.user_login}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="text-end mt-2">
                            {/* <button onClick={CreateArticle} className='btn btn-primary'>Import Article</button> */}
                            <img
                              data-toggle="tooltip"
                              data-placement="bottom"
                              type="button"
                              onClick={() => CreateArticleWord()}
                              // disabled={wordUpload ? true : false}
                              // width={40}
                              title="Import Article"
                              src={ImportArticleImage}
                              alt=""
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* </form> */}
                  </div>
                  <div className="col-3"></div>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          {/* upload word  doc modal convert end */}

          {loader ? (
            <div
              className="w-100"
              style={{ minHeight: "80vh", padding: "20px 30px 20px 50px" }}
            >
              <div
                style={{
                  // background: '#ececec',
                  boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.5)",
                  // margin: '20px 30px'
                }}
                className="row w-100"
              >
                <div className="all-articles col" style={{ minHeight: "66vh" }}>
                  <div className="d-flex justify-content-between">
                    <div className="d-flex ">
                      <h2 className="pt-3 mb-0 fw-bold pe-3">My Articles</h2>
                      {/*  */}
                      <div className="ps-3 pt-2" style={{}}>
                        <h5>Storage Space</h5>
                        {/* <p>
                          Pdf:{getPdfFile} Docx:{getDocxFile} Pptx:
                          {getPptxFile}
                        </p> */}

                        <div className="pb-3">
                          <img
                            src={PdfImg}
                            className="ps-3"
                            // width={40}
                            alt=""
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="PDf"
                            role="button"
                          />
                          :{" "}
                          <label htmlFor="" className="fw-bold">
                            {getPdfFile}
                          </label>
                          <img
                            className="ps-3"
                            // width={40}
                            src={DocxImg}
                            alt=""
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="DOC"
                            role="button"
                          />
                          :{" "}
                          <label htmlFor="" className="fw-bold">
                            {getDocxFile}
                          </label>
                          <img
                            className="ps-3"
                            // width={40}
                            src={PptxImg}
                            alt=""
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="PPT"
                            role="button"
                          />
                          :{" "}
                          <label htmlFor="" className="fw-bold">
                            {getPptxFile}
                          </label>
                        </div>

                        <div style={{ width: "60%" }}>
                          <ProgressBar
                            now={(usedSpace / TotalSpace) * 100}
                            label={`${Math.min(
                              (usedSpace / TotalSpace) * 100,
                              100
                            ).toFixed(2)}%`}
                          />
                        </div>
                        <div className="d-flex" style={{ marginTop: "10px" }}>
                          <p className="m-0 ">
                            Total Space: {TotalSpace.toFixed(2)} GB
                          </p>
                          <p className="m-0 px-2">
                            Used Space:
                            {usedSpace > TotalSpace
                              ? TotalSpace
                              : usedSpace.toFixed(2)}{" "}
                            GB
                          </p>
                          <p className="m-0">
                            Available Space:{" "}
                            {usedSpace > TotalSpace
                              ? 0
                              : availableSpace.toFixed(2)}{" "}
                            GB
                          </p>
                        </div>
                      </div>
                      {/*  */}
                    </div>
                    {/*  */}
                    <div className="d-flex " style={{ alignItems: "flex-end" }}>
                      {rolles == "administrator" || "author" ? (
                        <div>
                          <div className="d-flex align-items-center pt-2">
                            {/* <button
                              onClick={bulkDelete}
                              className="btn btn-primary "
                              disabled={disable}
                            >
                              Bulk Delete
                            </button> */}
                            <img
                              className=" me-1  commonLogo"
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title="Bulk Delete"
                              role="button"
                              onClick={bulkDelete}
                              src={BulkDelete}
                              alt=""
                            />
                            <img
                              className="me-2 commonLogo"
                              // width={40}
                              onClick={onpenModal}
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title="Embed Article"
                              role="button"
                              src={ImportArticleImage}
                              alt=""
                            />
                            <img
                              className="me-2 commonLogo"
                              width={20}
                              onClick={() => setModalShowWordDoc(true)}
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title="Import Article"
                              role="button"
                              src={UploadWordDoc}
                              alt=""
                            />
                            <div>
                              {/* <label htmlFor="authorDropdown">Select Author: </label> */}
                              <select
                                id="authorDropdown"
                                onChange={handleAuthorChange}
                                value={selectedAuthor}
                                disabled={disable}
                              >
                                <option value="0">Select an author</option>
                                {authors.map((author) => (
                                  <option key={author.ID} value={author.ID}>
                                    {author.user_login}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div>
                              {/* <button onClick={transferAuthors} className='btn btn-primary' disabled={disable}>Transfer Author</button> */}
                              <img
                                className="ms-2 commonLogo"
                                disabled={disable}
                                // width={40}
                                onClick={transferAuthors}
                                data-toggle="tooltip"
                                data-placement="bottom"
                                title="Transfer Author"
                                role="button"
                                src={TransferAuthorImage}
                                alt=""
                              />
                            </div>
                            <div>
                              {/* <button onClick={createPostHandel} className='mb-0 me-1 btn btn-primary ' style={{ width: '208px' }}> + Create Article</button> */}
                              <img
                                className="ms-1 commonLogo"
                                // width={35}
                                onClick={createPostHandel}
                                data-toggle="tooltip"
                                data-placement="bottom"
                                title="Create Article"
                                role="button"
                                src={CreateArticleImage}
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {/*  */}

                      <div>
                        {/* <button onClick={createPostHandel} className='mb-0 me-1 btn btn-primary ' style={{ width: '208px' }}> + Create Article</button> */}
                        {/* <img
                          className="ms-2 commonLogo"
                          // width={35}
                          onClick={createPostHandel}
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="Create Article"
                          role="button"
                          src={CreateArticleImage}
                          alt=""
                        /> */}
                      </div>
                    </div>
                  </div>
                  <div>
                    {rolles == "administrator" || "author" || "editor" ? (
                      <MDBDataTable
                        noRecordsFoundLabel={`${articleData.length < 1
                          ? 'Create your first article  by clicking on "+ CREATE ARTICLE" button'
                          : "No matching records found"
                          }`}
                        fixed
                        sortable
                        bordered
                        autoWidth={false}
                        data={data}
                        entries={5}
                        entriesOptions={[5, 10, 15, 20]}
                        noBottomColumns
                        disableRetreatAfterSorting={true}
                      />
                    ) : (
                      <MDBDataTable
                        noRecordsFoundLabel={`${articleData.length < 1
                          ? 'Create your first article  by clicking on "+ CREATE ARTICLE" button'
                          : "No matching records found"
                          }`}
                        fixed
                        sortable
                        bordered
                        autoWidth={false}
                        data={data2}
                        entries={5}
                        entriesOptions={[5, 10, 15, 20]}
                        noBottomColumns
                        disableRetreatAfterSorting={true}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center w-100 my-5">
              <Spinner />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TablePosts;
